<template>
  <div class="error-cant-fetch alert -danger">
    <template slot="title">Ops!</template>

    <p>Infelizmente aconteceu um erro ao tentar carregar as informações para se iniciar a consulta, por favor tente novamente.</p>
  </div>
</template>

<script>
export default {
  name: 'ErrorCantFetch',
};
</script>

<style lang="scss" scoped>
  .error-cant-fetch {
    @apply mb-4;
  }
</style>
